import * as React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, makeStyles } from '@material-ui/core';
import { useIifImportSelector, IifImportSelectors } from '../store/modules/iifImport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown';
import ExpenseView from './ExpenseView';
import { useApplicationSettingsSelector, ApplicationSettingsSelectors, TaxMode } from '../store/modules/applicationSettings';
import AudCurrencyFormatter from '../utilities/currencyFormatter';
import DepositView from './DepositView';
import * as Dtos from '../api/dtos';

interface IDepositsViewProps {
    fileIndex: number;
    depositView: number[];
    amount: number;
    tax: number;
    total: number;
    errors?: Dtos.ResponseError[];
}

const useStyles = makeStyles(theme => ({
    expandCell: {
        width: 75
    },
    indexCell: {
        width: 75
    },
    dateCell: {
        width: 120
    },
    referenceCell: {
        width: 220
    },
    currencyCell: {
        width: 150
    },
    amountCell: {
        width: 150
    },
    totalCell: {
        fontWeight: 'bold'
    },
    totalAmountCell: {
        fontWeight: 'bold'
    },
    hiddenCell: {
        border: 'none'
    },
    title: {
        marginTop: theme.spacing(4)
    }
}))

const DepositsView: React.FunctionComponent<IDepositsViewProps> = ({
    fileIndex,
    depositView,
    tax,
    amount,
    total,
    errors
}) => {
    const classes = useStyles();

    const taxMode = useApplicationSettingsSelector(ApplicationSettingsSelectors.selectTaxMode);

    if (!depositView || depositView.length === 0) {
        return null;
    }

    const hasErrors = !!errors;

    return (
        <>
            <Typography variant="h3" className={classes.title}>Deposits</Typography>
            <Table aria-label="spanning table" size="small">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.expandCell} />
                        <TableCell className={classes.indexCell}>#</TableCell>
                        <TableCell className={classes.dateCell} >Date</TableCell>
                        <TableCell>Account</TableCell>
                        <TableCell className={classes.referenceCell}>Reference</TableCell>
                        <TableCell className={classes.currencyCell}>Currency</TableCell>
                        <TableCell className={classes.amountCell} align="right">Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        depositView?.map((depositIndex, index) => {
                            const isError = !!errors ? errors.some(e => !!e.meta && !!e.meta.type && !!e.meta.position && e.meta.type === 'Deposit' && e.meta.position === (index + 1).toString()) : false;

                            return (
                                <DepositView
                                    key={depositIndex}
                                    fileIndex={fileIndex}
                                    depositIndex={depositIndex}
                                    depositPosition={index + 1}
                                    importSuccess={hasErrors && !isError}
                                    importError={hasErrors && isError}
                                />
                            );
                        })
                    }
                    {
                        taxMode === TaxMode.Excluded && (
                            <>
                                <TableRow>
                                    <TableCell className={classes.hiddenCell} colSpan={5} />
                                    <TableCell className={classes.totalCell}>SUBTOTAL</TableCell>
                                    <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(amount)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.hiddenCell} colSpan={5} />
                                    <TableCell className={classes.totalCell}>TAX</TableCell>
                                    <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(tax)}</TableCell>
                                </TableRow>
                            </>
                         )
                    }
                    <TableRow>
                        <TableCell className={classes.hiddenCell} colSpan={5} />
                        <TableCell className={classes.totalCell}>TOTAL</TableCell>
                        <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(total)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    );
}

export default DepositsView;


// WEBPACK FOOTER //
// ./src/components/DepositsView.tsx